import {request} from '@/utils/http';

let homeList = '/fronted/portal';
let noticeList = '/fronted/article/all'
let certificate = '/fronted/article/certificate'
let articleGroup = '/fronted/article/group'
let articleSimple = '/fronted/article/simple'
let screen='/fronted/fronted/alert_screen'


export function POST_HOMELIST(params){
  let headers={'Content-Type': 'application/json'}
  return request(homeList,'post',params,headers,true)
}
export function GET_NOTICELIST(params){
  return request(noticeList,'get',params)
}
export function GET_CERTIFICATE(params){
  return request(certificate,'get',params)
}
export function GET_ARTICLEGROUP(params){
  return request(articleGroup,'get',params)
}
export function GET_ARTICLESIMPLE(params){
  return request(articleSimple,'get',params)
}
export function GET_ALERTSCREEN(params){
  return request(screen,'get',params)
}


// WEBPACK FOOTER //
// ./src/api/home.api.js